// extracted by mini-css-extract-plugin
module.exports = {"svg":"arrow-module--svg--29YuQ"};